import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { Observable } from 'rxjs';
import { ISbComponentType } from 'storyblok-js-client';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const storyblokRelationshipsResolver: ResolveFn<
  Observable<
    ISbStoryData<
      ISbComponentType<string> & {
        [index: string]: unknown;
      }
    >[]
  >
> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  return storyblokService.resolveRelationships(route);
};
